import styled from "styled-components/macro";
import { Button, InputControl } from "../../../../components";
import { media } from "../../../../utils";

export const BoletoActionIcon = styled.svg({});

export const BoletoActionLabel = styled.span({
  [media.md()]: {
    fontSize: "14px",
  },
});

export const BoletoAction = styled.a({
  width: "100%",
  padding: "24px 0",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  textDecoration: "none",
  [`${BoletoActionIcon}, ${BoletoActionLabel}`]: {
    margin: "0 4px",
    color: "#005FC8",
  },
  [media.md()]: {},
});

export const BoletoActionContent = styled.div({
  width: "100%",
});

export const DetailItemLabel = styled.legend({
  marginBottom: "4px",
  color: "#6F7C87",
});
export const DetailItemValue = styled.span({
  margin: 0,
});
export const DetailItem = styled.div({
  padding: "12px 0",
});

export const BoletoDailsContent = styled.div({
  width: "100%",
  display: "grid",
  gridTemplateColumns: "2fr 3fr",
  padding: "16px",
});
export const CabecalhoDesktop = styled.div({
  display: "none !important",
  [media.md()]: {
    display: "flex !important",
    [`${DetailItem}`]: {
      padding: "0 !important",
      marginBottom: "12px",
      [`${DetailItemLabel}`]: {
        display: "inline !important",
      },
    },
  },
});

export const BoletoDetails = styled.div(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
  boxShadow: "0px 8px 12px 0px #2D292629, 0px -2px 2px 0px #2D29260D",
  padding: "0",
  marginBottom: "32px",
  [`${BoletoDailsContent}, ${BoletoDailsContent}`]: {
    borderBottom: "1px solid #D1DBE3",
  },
  [media.md()]: {
    flexWrap: "nowrap",
    boxShadow: "none",
    alignItems: "center",
    marginBottom: "0",
    borderBottom: "1px solid #D1DBE3",
    [`${DetailItemLabel}, ${BoletoActionIcon}`]: {
      display: "none",
    },
    [`${BoletoDailsContent}`]: {
      display: "flex",
      borderBottom: "none",
      padding: 0,
      [`${DetailItem}`]: {
        width: "100%",
        borderBottom: "none",
        padding: "20px 0",
      },
    },
    [`${BoletoActionContent}`]: {
      display: "flex",
      maxWidth: "130px",
      [`${BoletoAction}`]: {
        padding: 0,
        maxWidth: "132px",
        height: "32px",
        background: "transparent",
        borderRadius: "500px",
        color: theme.color.brandPrimary.light,
        border: `1px solid ${theme.color.brandPrimary.light} !important`,
        "&:hover:not(:disabled)": {
          background: theme.color.brandPrimary.light,
          [` ${BoletoActionLabel}`]: {
            color: `${theme.color.neutral["08"]} !important`,
          },
        },
        "&:active:not(:disabled)": {
          background: theme.color.brandPrimary.medium,
          [` ${BoletoActionLabel}`]: {
            color: `${theme.color.neutral["08"]} !important`,
          },
        },
      },
    },
  },
}));

export const DisplayQuantidade = styled.span({
  [media.md]: {
    display: "none",
  },
});

export const BoletosAberto = styled.div({
  display: "block",
  margin: "0 auto",
  padding: "16px 0",
});

export const ResetForm = styled.button({
  background: "transparent",
  border: "none",
  padding: 0,
  [`${BoletoActionLabel}`]: {
    textDecoration: "underline",
    textUnderlineOffset: "0.17rem",
    lineHeight: "150%",
  },
  [media.lg()]: {
    marginTop: "20px",
    width: "auto",
  },
});

export const DescriptionConsorcio = styled.span(({ theme }) => ({
  color: theme.color.neutral["03"],
}));

export const ErrorModalButton = styled.button({
  display: "block",
  width: "100%",
  maxWidth: "384px",
  margin: "20px auto",
});

export const CustomCloseModal = styled(ErrorModalButton)({
  border: "none !important",
  [media.lg()]: {
    border: "1px solid #005FC8 !important",
  },
});

export const CustomModalError = styled.div({
  "&.active": {
    maxHeight: "372px !important",
    [media.lg()]: {
      maxHeight: "initial !important",
    },
  },
});

export const GrupoCotaContent = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const InputGrupoCota = styled(InputControl)`
  width: 160px;
  input {
    width: 100%;
  }

  ${media.md()} {
    width: 45%;
  }
`;

export const ButtonForm = styled(Button)`
  width: 100%;
`;
